<script setup lang="ts">
import { defineProps } from 'vue';

const props = defineProps<{
  onClick?: () => void;
  class?: string | object;
  link?: string;
  disabled?: boolean;
}>();
</script>

<template>
  <button v-if="!props.link" class="button" :class="props.class" :disabled="disabled" @click="() => props.onClick && props.onClick()">
    <slot></slot>
  </button>

  <a v-else :href="props.link" class="button" :class="props.class" @click="() => props.onClick && props.onClick()">
    <slot></slot>
  </a>
</template>
